
import type { PropType } from 'vue';

import {
  defineComponent,
  reactive,
  watch,
} from 'vue';
import { validate as validateUuid } from 'uuid';

import type { MaxClicksBySubid } from '@/types';

export default defineComponent({
  props: {
    modelValue: {
      type: Array as PropType<MaxClicksBySubid[]>,
      required: true,
    },
  },
  setup(props, { emit }) {
    const maxClicksBySubids = reactive<MaxClicksBySubid[]>([...props.modelValue]);

    const addMaxClicksBySubid = (): void => {
      maxClicksBySubids.push({
        key: null,
        value: 0,
      });
    };

    const deleteMaxClicksBySubid = (index: number): void => {
      maxClicksBySubids.splice(index, 1);
    };

    watch(
      maxClicksBySubids,
      () => emit('update:modelValue', maxClicksBySubids.filter((maxClicksBySubid: MaxClicksBySubid) => validateUuid(maxClicksBySubid.key ?? ''))),
    );

    return {
      maxClicksBySubids,
      addMaxClicksBySubid,
      deleteMaxClicksBySubid,
    };
  },
});
